import React from 'react';
import {useParams} from "react-router-dom";

import {Badge, Button, Col, Row} from "react-bootstrap";

import Clear from '../../icons/clear.png';
import Brightness from '../../icons/brightness.png';
import Unclear from '../../icons/unclear.png';

import CardPlaceholder from "./components/CardPlaceholder";

import styles from './SampleDataPage.module.css';
import UploadDocument from "./components/UploadDocument";

const UploadDocumentSection = (props) => {
    const params = useParams();

    const cards = [
        {
            src: Clear,
            alt: 'clear',
            isValid: true,
            description: 'Tulisan terbaca dengan jelas & tidak terpotong'
        },
        {
            src: Brightness,
            alt: 'brightness',
            isValid: false,
            description: 'Pastikan pencahayaan cukup & tidak terpantul cahaya'
        },
        {
            src: Unclear,
            alt: 'unclear',
            isValid: false,
            description: 'Gunakan foto/dokumen yang tidak buram'
        },
    ]

    const documents = [
        {name: 'npwp', label: 'NPWP'},
        {name: 'nib', label: 'NIB'},
        {name: 'akta_perubahan_sk_menkumham', label: 'Akta Perubahan / SK Menkumham'},
        {name: 'sppkp', label: 'SPPKP'},
        {name: 'nkv', label: 'NKV'},
        {name: 'sertifikat_halal', label: 'Sertifikat Halal'},
        {name: 'sertifikat_bpom', label: 'Sertifikat BPOM'},
        {name: 'pirt', label: 'PIRT'},
    ];

    return <>
        <Badge className={styles.codeBadge}>
            Kode Registrasi : {params.code}
        </Badge>
        <div className={`${styles.sectionCard} mt-3`}>
            <h5>Upload Dokumen</h5>
            <p>Pastikan dokumen sesuai dengan ketentuan. Format file harus JPG, JPEG, PNG, PDF (maks. 10MB)</p>
            <Row>
                {cards.map(card => {
                    return <Col lg={4}>
                        <CardPlaceholder src={card.src} alt={card.alt} isValid={card.isValid}/>
                        <small>
                            {card.description}
                        </small>
                    </Col>
                })}
            </Row>
        </div>
        <div className={`${styles.sectionCard} mt-3`}>
            <h5>Upload Dokumen</h5>
            {documents.map((document, index) => {
                return <UploadDocument key={index} {...props} index={index} name={document.name} label={document.label}/>
            })}
        </div>
        <div className={'mt-5'} style={{width: '90%'}}>
            <Button type={'button'} className={'float-end'} variant={"success"} onClick={props.forward}>
                Simpan
            </Button>
            <Button type={'button'} className={'float-end me-3'} variant={"outline-success"} onClick={props.back}>
                Kembali
            </Button>
        </div>
    </>
}

export default UploadDocumentSection;